import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
export interface Approver {
  id: string;
  name: string;
  designation: string;
  status: number;
  date: string;
  deleted: boolean;
}

export interface ViewRoutingContextValue {
  aboDetails: {
    name: string;
    affiliateCode: string;
    aboNumber: string;
    awardCode: string;
    awardName: string;
    awardTagCode: number;
    awardQualifiedMonth: string;
  }
  approvers: Approver[];
  setApprovers: Dispatch<SetStateAction<Approver[]>>;
  viewOnly: boolean;
  setViewOnly: Dispatch<SetStateAction<boolean>>
}

const viewRoutingContext = createContext<ViewRoutingContextValue | null>(null);

export const ViewRoutingProvider: React.FC<PropsWithChildren<{aboDetails: ViewRoutingContextValue["aboDetails"]}>> = ({
  aboDetails, children,
}) => {

  const [approvers, setApprovers] = useState<Approver[]>(
    []
  );

  const [viewOnly, setViewOnly] = useState(false);

  const value = useMemo<ViewRoutingContextValue>(() => {
    return {
      aboDetails,
      approvers,
      setApprovers,
      viewOnly,
      setViewOnly
    };
  }, [aboDetails, approvers, viewOnly]);

  return (
    <viewRoutingContext.Provider value={value}>
      {children}
    </viewRoutingContext.Provider>
  );
};

export const useViewRoutingContext = () => {
  const value = useContext(viewRoutingContext);
  if (!value)
    throw new Error(
      "Cannot use useViewRoutingContext outside of ViewRoutingProvider !"
    );

  return value;
};